import { spacing } from 'ui/theme';
import { Platform } from '../constants';
import { MediaLayoutProp } from '../types';
import { Message } from './Message';
import { DesktopLayout, DesktopRow, Filler, FillerRow } from './styles';

export const DesktopPreview = ({ mediaLayout }: MediaLayoutProp) => {
  return (
    <DesktopLayout>
      <Filler flexGrow={2} minHeight={spacing.double} />
      <Filler minHeight={spacing.base} />
      <DesktopRow>
        <Message platform={Platform.DESKTOP} mediaLayout={mediaLayout} />
        <Filler />
      </DesktopRow>
      <FillerRow mediaLayout={mediaLayout}>
        <Filler />
        <Filler />
        <Filler />
      </FillerRow>
    </DesktopLayout>
  );
};
